(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    // Clamp quantity fields to their per-order cap. `max` gives us native
    // validation on submit, but a line can already exceed it (added from
    // another tab, or before the metafield was set), so clamp on load too.
    const inputs = Array.prototype.slice.call(
      document.querySelectorAll('[data-cart-quantity-input][max]')
    );
    if (!inputs.length) return;

    function maxOf(input) {
      return parseInt(input.getAttribute('max'), 10) || 0;
    }

    function valueOf(input) {
      const value = parseInt(input.value, 10);
      return isNaN(value) ? 0 : value;
    }

    // Pooled products (e.g. every pillow) share one cap, so the whole pool has
    // to be clamped together — trimming the later rows first.
    function clampPools() {
      const pools = {};
      inputs.forEach(function (input) {
        const group = input.getAttribute('data-quantity-group');
        if (!group) return;
        (pools[group] = pools[group] || []).push(input);
      });

      Object.keys(pools).forEach(function (group) {
        const members = pools[group];

        let max = 0;
        members.forEach(function (input) {
          const cap = maxOf(input);
          if (cap > 0 && (max === 0 || cap < max)) max = cap;
        });
        if (max <= 0) return;

        let total = members.reduce(function (sum, i) { return sum + valueOf(i); }, 0);
        for (let i = members.length - 1; i >= 0 && total > max; i--) {
          const value = valueOf(members[i]);
          const next = Math.max(0, value - (total - max));
          if (next === value) continue;
          members[i].value = String(next);
          total -= value - next;
        }
      });
    }

    function clampAll() {
      inputs.forEach(function (input) {
        const max = maxOf(input);
        if (max && valueOf(input) > max) input.value = String(max);
      });
      clampPools();
    }

    clampAll();
    inputs.forEach(function (input) {
      input.addEventListener('input', clampAll);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const toggle = header.querySelector('[data-mobile-menu-toggle]');
    const drawer = header.querySelector('[data-mobile-menu]');
    const searchToggle = header.querySelector('[data-mobile-search-toggle]');
    const searchPanel = header.querySelector('[data-mobile-search]');
    const searchInput = searchPanel ? searchPanel.querySelector('[data-mobile-search-input]') : null;
    const root = drawer ? drawer.querySelector('[data-mobile-panel="root"]') : null;
    const subPanels = drawer ? drawer.querySelectorAll('[data-mobile-panel="sub"]') : [];
    const openButtons = drawer ? drawer.querySelectorAll('[data-mobile-submenu-open]') : [];
    const backButtons = drawer ? drawer.querySelectorAll('[data-mobile-submenu-back]') : [];
    const navItems = header.querySelectorAll('[data-nav-item][data-has-mega="true"]');

    function openSearch() {
      if (!searchPanel) return;
      closeDrawer();
      searchPanel.hidden = false;
      searchPanel.classList.add('header__mobile-search--active');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      if (searchInput) searchInput.focus();
    }

    function closeSearch() {
      if (!searchPanel) return;
      searchPanel.hidden = true;
      searchPanel.classList.remove('header__mobile-search--active');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }

    function openDrawer() {
      if (!drawer) return;
      closeSearch();
      drawer.hidden = false;
      drawer.classList.add('header__mobile-menu--active');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.hidden = true;
      drawer.classList.remove('header__mobile-menu--active');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hideAllSubs();
    }

    function hideAllSubs() {
      subPanels.forEach(function (p) {
        p.classList.remove('header__mobile-panel--active');
        p.setAttribute('aria-hidden', 'true');
      });
      openButtons.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (root) root.classList.remove('header__mobile-panel--pushed');
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (drawer.hidden) openDrawer();
        else closeDrawer();
      });
    }

    if (searchToggle) {
      searchToggle.addEventListener('click', function () {
        if (searchPanel.hidden) openSearch();
        else closeSearch();
      });
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const targetId = btn.getAttribute('data-target');
        const panel = document.getElementById(targetId);
        if (!panel) return;
        hideAllSubs();
        panel.classList.add('header__mobile-panel--active');
        panel.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        if (root) root.classList.add('header__mobile-panel--pushed');
        // Move focus to back button for keyboard users
        const back = panel.querySelector('[data-mobile-submenu-back]');
        if (back) back.focus();
      });
    });

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const panel = btn.closest('[data-mobile-panel="sub"]');
        hideAllSubs();
        const opener = document.querySelector('[data-mobile-submenu-open][data-target="' + (panel ? panel.id : '') + '"]');
        if (opener) opener.focus();
      });
    });

    // Desktop mega menu: add a slight close delay so pointer travel from
    // parent link to panel feels forgiving.
    const megaCloseDelay = 180;

    navItems.forEach(function (item) {
      const link = item.querySelector('.header__nav-link');
      if (!link) return;

      let closeTimer = null;

      function clearCloseTimer() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      }

      function setExpanded(value) {
        link.setAttribute('aria-expanded', value ? 'true' : 'false');
        item.classList.toggle('is-mega-open', value);
      }

      function openMega() {
        clearCloseTimer();
        setExpanded(true);
      }

      function closeMegaSoon() {
        clearCloseTimer();
        closeTimer = setTimeout(function () {
          setExpanded(false);
          closeTimer = null;
        }, megaCloseDelay);
      }

      item.addEventListener('mouseenter', openMega);
      item.addEventListener('mouseleave', closeMegaSoon);
      item.addEventListener('focusin', openMega);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMegaSoon();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (drawer && !drawer.hidden) {
          closeDrawer();
          if (toggle) toggle.focus();
        }
        if (searchPanel && !searchPanel.hidden) {
          closeSearch();
          if (searchToggle) searchToggle.focus();
        }
        navItems.forEach(function (item) {
          const link = item.querySelector('.header__nav-link');
          if (link && link.getAttribute('aria-expanded') === 'true') {
            link.setAttribute('aria-expanded', 'false');
            link.focus();
            link.blur();
          }
        });
      }
    });

    // Sticky-on-scroll behaviour preserved
    const headerHeight = 188;
    const sectionId = header.getAttribute('data-section-id');
    const sectionElement = document.getElementById('shopify-section-' + sectionId);
    let lastScrollY = 0;

    function handleScroll() {
      const currentScrollY = window.scrollY;
      const isScrollingUp = currentScrollY < lastScrollY;

      if (currentScrollY > headerHeight) {
        if (!sectionElement.classList.contains('header-section-scrolled')) {
          document.body.style.paddingTop = sectionElement.offsetHeight + 'px';
          sectionElement.classList.add('header-section-scrolled');
        }
        if (isScrollingUp) {
          sectionElement.classList.add('header-section-scrolled--show');
        } else {
          sectionElement.classList.remove('header-section-scrolled--show');
        }
      } else {
        document.body.style.paddingTop = '0';
        sectionElement.classList.remove('header-section-scrolled', 'header-section-scrolled--show');
      }

      lastScrollY = currentScrollY;
    }

    function debounce(fn, wait) {
      let t;
      return function () {
        const args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    }

    window.addEventListener('scroll', debounce(handleScroll, 10));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SELECTOR = '[data-hero-slider]';
    var initialised = new WeakSet();

    function HeroSlider(root) {
      this.root = root;
      this.track = root.querySelector('[data-hero-track]');
      this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
      this.prevBtn = root.querySelector('[data-hero-prev]');
      this.nextBtn = root.querySelector('[data-hero-next]');
      this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
      this.live = root.querySelector('[data-hero-live]');
      this.count = this.slides.length;
      this.index = 0;

      // Drag state
      this.dragging = false;
      this.startX = 0;
      this.deltaX = 0;
      this.width = 0;
      this.justDragged = false;

      // Pre-bound handlers so they can be removed on destroy
      this.onPrev = this.prev.bind(this);
      this.onNext = this.next.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onDotClick = this.handleDotClick.bind(this);
      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onPointerMove = this.handlePointerMove.bind(this);
      this.onPointerUp = this.handlePointerUp.bind(this);
      this.onClickCapture = this.handleClickCapture.bind(this);

      this.setup();
    }

    HeroSlider.prototype.setup = function () {
      var self = this;

      // Single slide: nothing to navigate, just make sure it is exposed.
      this.updateSlides();
      if (this.count <= 1) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { self.goTo(i); });
      });

      this.root.addEventListener('keydown', this.onKeydown);
      this.track.addEventListener('pointerdown', this.onPointerDown);
      // Capture-phase click guard so a drag never triggers a CTA navigation.
      this.track.addEventListener('click', this.onClickCapture, true);

      this.goTo(0, { announce: false });
    };

    HeroSlider.prototype.goTo = function (index, options) {
      var opts = options || {};
      this.index = Math.max(0, Math.min(index, this.count - 1));
      this.track.style.transform = 'translate3d(' + (-this.index * 100) + '%, 0, 0)';
      this.updateControls();
      this.updateSlides();
      if (opts.announce !== false) this.announce();
    };

    HeroSlider.prototype.next = function () { this.goTo(this.index + 1); };
    HeroSlider.prototype.prev = function () { this.goTo(this.index - 1); };

    HeroSlider.prototype.updateControls = function () {
      var atStart = this.index === 0;
      var atEnd = this.index === this.count - 1;

      // Move focus off a control before it becomes disabled (it would
      // otherwise lose focus silently).
      if (this.prevBtn && atStart && document.activeElement === this.prevBtn && this.nextBtn) {
        this.nextBtn.focus();
      }
      if (this.nextBtn && atEnd && document.activeElement === this.nextBtn && this.prevBtn) {
        this.prevBtn.focus();
      }

      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;

      var current = this.index;
      this.dots.forEach(function (dot, i) {
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    HeroSlider.prototype.updateSlides = function () {
      var current = this.index;
      var supportsInert = 'inert' in HTMLElement.prototype;
      this.slides.forEach(function (slide, i) {
        var active = i === current;
        if (supportsInert) {
          slide.inert = !active;
        } else {
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        }
      });
    };

    HeroSlider.prototype.announce = function () {
      if (!this.live) return;
      var template = this.live.getAttribute('data-position-template') || 'CURRENT / TOTAL';
      this.live.textContent = template
        .replace('CURRENT', this.index + 1)
        .replace('TOTAL', this.count);
    };

    HeroSlider.prototype.handleKeydown = function (event) {
      var tag = event.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          this.prev();
          break;
        case 'ArrowRight':
          event.preventDefault();
          this.next();
          break;
        case 'Home':
          event.preventDefault();
          this.goTo(0);
          break;
        case 'End':
          event.preventDefault();
          this.goTo(this.count - 1);
          break;
        default:
          break;
      }
    };

    HeroSlider.prototype.handleDotClick = function (event) {
      var index = this.dots.indexOf(event.currentTarget);
      if (index > -1) this.goTo(index);
    };

    HeroSlider.prototype.handlePointerDown = function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.dragging = true;
      this.startX = event.clientX;
      this.deltaX = 0;
      this.width = this.track.getBoundingClientRect().width || 1;
      this.track.style.transition = 'none';
      if (this.track.setPointerCapture) {
        this.track.setPointerCapture(event.pointerId);
      }
      this.track.addEventListener('pointermove', this.onPointerMove);
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.track.addEventListener('pointercancel', this.onPointerUp);
    };

    HeroSlider.prototype.handlePointerMove = function (event) {
      if (!this.dragging) return;
      this.deltaX = event.clientX - this.startX;
      var offset = (this.deltaX / this.width) * 100;
      var base = -this.index * 100;
      // Add resistance when dragging past the first/last slide.
      if ((this.index === 0 && this.deltaX > 0) ||
          (this.index === this.count - 1 && this.deltaX < 0)) {
        offset = offset / 3;
      }
      this.track.style.transform = 'translate3d(' + (base + offset) + '%, 0, 0)';
    };

    HeroSlider.prototype.handlePointerUp = function (event) {
      if (!this.dragging) return;
      this.dragging = false;
      this.track.style.transition = '';
      this.justDragged = Math.abs(this.deltaX) > 5;

      var threshold = Math.max(40, this.width * 0.15);
      if (this.deltaX <= -threshold) this.next();
      else if (this.deltaX >= threshold) this.prev();
      else this.goTo(this.index, { announce: false }); // snap back

      if (this.track.releasePointerCapture && event.pointerId != null) {
        try { this.track.releasePointerCapture(event.pointerId); } catch (e) {}
      }
      this.track.removeEventListener('pointermove', this.onPointerMove);
      this.track.removeEventListener('pointerup', this.onPointerUp);
      this.track.removeEventListener('pointercancel', this.onPointerUp);
      this.deltaX = 0;
    };

    HeroSlider.prototype.handleClickCapture = function (event) {
      if (this.justDragged) {
        event.preventDefault();
        event.stopPropagation();
        this.justDragged = false;
      }
    };

    // Move to the slide containing a given element (Theme Editor block select).
    // The selected element may be the slide, a descendant, or a platform
    // wrapper around it, so check ancestors then descendants.
    HeroSlider.prototype.goToElement = function (element) {
      var slide = element.closest ? element.closest('[data-hero-slide]') : null;
      if (!slide && element.querySelector) slide = element.querySelector('[data-hero-slide]');
      if (!slide) return;
      var index = this.slides.indexOf(slide);
      if (index > -1) this.goTo(index);
    };

    HeroSlider.prototype.destroy = function () {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      this.root.removeEventListener('keydown', this.onKeydown);
      if (this.track) {
        this.track.removeEventListener('pointerdown', this.onPointerDown);
        this.track.removeEventListener('pointermove', this.onPointerMove);
        this.track.removeEventListener('pointerup', this.onPointerUp);
        this.track.removeEventListener('pointercancel', this.onPointerUp);
        this.track.removeEventListener('click', this.onClickCapture, true);
      }
    };

    function initWithin(scope) {
      var context = scope || document;
      var nodes = Array.prototype.slice.call(context.querySelectorAll(SELECTOR));
      if (context.nodeType === 1 && context.matches && context.matches(SELECTOR)) {
        nodes.push(context);
      }
      nodes.forEach(function (node) {
        if (initialised.has(node)) return;
        initialised.add(node);
        node.heroSlider = new HeroSlider(node);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initWithin(document); });
    } else {
      initWithin(document);
    }

    // Shopify Theme Editor lifecycle
    document.addEventListener('shopify:section:load', function (event) {
      initWithin(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var node = event.target.querySelector(SELECTOR);
      if (node && node.heroSlider) {
        node.heroSlider.destroy();
        initialised.delete(node);
        node.heroSlider = null;
      }
    });

    document.addEventListener('shopify:block:select', function (event) {
      var node = event.target.closest ? event.target.closest(SELECTOR) : null;
      if (node && node.heroSlider) node.heroSlider.goToElement(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wire each newsletter form to Attentive's sign-up unit trigger.
    // Attentive tag API: window.__attentive.trigger(filter, client_id, email, creative_id)
    document.querySelectorAll('form[data-newsletter-attentive]').forEach(function (form) {
      if (form.dataset.newsletterBound) return;
      form.dataset.newsletterBound = 'true';

      var emailInput = form.querySelector('input[type="email"]');
      var error = form.querySelector('[data-newsletter-error]');

      function showError(message) {
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var email = (emailInput && emailInput.value || '').trim();
        if (!email || !emailInput.checkValidity()) {
          emailInput.reportValidity();
          return;
        }

        var creativeId = form.dataset.attentiveCreativeId || null;
        var clientId = form.dataset.attentiveClientId || null;

        if (!window.__attentive || typeof window.__attentive.trigger !== 'function') {
          // Attentive tag not present/loaded — fail loud so it's caught in testing.
          showError('Sorry, sign-up is temporarily unavailable. Please try again later.');
          if (window.console) console.error('[newsletter] Attentive tag not found on page.');
          return;
        }

        try {
          // Numeric creative IDs should be passed as numbers; fall back to raw string.
          var creative = creativeId && /^\d+$/.test(creativeId) ? Number(creativeId) : creativeId;
          // Opens the Attentive fullscreen sign-up unit with the email prefilled.
          // The user completes the consented opt-in INSIDE that unit — Attentive's
          // UI provides the actual confirmation, so we don't show our own success
          // message (that would claim success before they've confirmed).
          window.__attentive.trigger(null, clientId, email, creative);
        } catch (err) {
          showError('Something went wrong. Please try again.');
          if (window.console) console.error('[newsletter] Attentive trigger failed:', err);
          return;
        }

        if (error) error.hidden = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (el) {
      // If the server has already rendered recommendations, skip.
      if (el.querySelector('.product-recommendations__list')) return;

      const url = el.getAttribute('data-url');
      if (!url) return;

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-product-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
          } else {
            el.style.display = 'none';
          }
        })
        .catch(function () { el.style.display = 'none'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-product]');
    sections.forEach(initProduct);

    document.querySelectorAll('[data-media-slider]').forEach(initMediaSlider);

    function initMediaSlider(slider) {
      const track = slider.querySelector('[data-media-track]');
      if (!track) return;
      const slides = track.children;
      if (slides.length < 2) return;

      const dots = Array.prototype.slice.call(slider.querySelectorAll('[data-media-dot]'));
      const prev = slider.querySelector('[data-media-prev]');
      const next = slider.querySelector('[data-media-next]');

      // Keep the lg breakpoint in sync with the Tailwind `lg:` markup above.
      const mobile = window.matchMedia('(max-width: 1023px)');

      function currentIndex() {
        if (!track.clientWidth) return 0;
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function goTo(i) {
        const idx = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      }

      function update() {
        const idx = currentIndex();
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
        if (prev) prev.disabled = idx <= 0;
        if (next) next.disabled = idx >= slides.length - 1;
      }

      let ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      }
      function onPrev() { goTo(currentIndex() - 1); }
      function onNext() { goTo(currentIndex() + 1); }
      function onDot() { goTo(parseInt(this.dataset.index, 10) || 0); }

      let bound = false;
      function enable() {
        if (bound) return;
        bound = true;
        track.addEventListener('scroll', onScroll);
        dots.forEach(function (dot) { dot.addEventListener('click', onDot); });
        if (prev) prev.addEventListener('click', onPrev);
        if (next) next.addEventListener('click', onNext);
        update();
      }
      function disable() {
        if (!bound) return;
        bound = false;
        track.removeEventListener('scroll', onScroll);
        dots.forEach(function (dot) { dot.removeEventListener('click', onDot); });
        if (prev) prev.removeEventListener('click', onPrev);
        if (next) next.removeEventListener('click', onNext);
        // Reset any leftover scroll offset so the desktop grid isn't shifted.
        track.scrollLeft = 0;
      }

      function sync() {
        if (mobile.matches) enable();
        else disable();
      }

      mobile.addEventListener('change', sync);
      sync();
    }

    function initProduct(root) {
      console.log("init product");
      const productData = window.__productJson_init && window.__productJson_init[root.dataset.sectionId];

      const moneyFormat = root.dataset.moneyFormat || ('£' + '{' + '{amount}' + '}');
      const i18n = {
        addToBag: root.dataset.i18nAddToBag,
        soldOut: root.dataset.i18nSoldOut,
        unavailable: root.dataset.i18nUnavailable,
        was: root.dataset.i18nWas,
        maxQty: root.dataset.i18nMaxQty,
        maxQtyRemaining: root.dataset.i18nMaxQtyRemaining,
        maxQtyReached: root.dataset.i18nMaxQtyReached,
        maxQtyButton: root.dataset.i18nMaxQtyButton,
        maxQtyGroup: root.dataset.i18nMaxQtyGroup,
        maxQtyGroupRemaining: root.dataset.i18nMaxQtyGroupRemaining,
        maxQtyGroupReached: root.dataset.i18nMaxQtyGroupReached,
      };

      // variant id -> per-order limit (0 = unlimited)
      const qtyLimits = (window.__quantityLimits_init && window.__quantityLimits_init[root.dataset.sectionId]) || {};
      // Pool this product shares its cap with, e.g. 'pillows'. Empty when the
      // cap applies to this product alone.
      const qtyGroup = root.dataset.quantityGroup || '';
      // Bag state published by the side cart; see snippets/cart-quantity-state.liquid
      let cartState = { variants: {}, groups: {} };

      const variantInput = root.querySelector('[data-variant-id]');
      const optionInputs = root.querySelectorAll('[data-option-input]');
      const submitBtn = root.querySelector('[data-add-to-cart]');
      const submitText = root.querySelector('[data-add-to-cart-text]');
      const priceCurrent = root.querySelector('.product__price-current');
      const priceWas = root.querySelector('.product__price-was');
      const fieldsets = root.querySelectorAll('[data-product-option]');
      const descRoot = root.querySelector('[data-product-description]');
      const qtyInput = root.querySelector('[data-quantity-input]');

      const reviewsBtn = root.querySelector('#reviews-button');
      const reviewsDetails = root.querySelector('#reviews-details');
      console.log("reviews button", reviewsBtn, reviewsDetails);
      if (reviewsBtn && reviewsDetails) {
        reviewsBtn.addEventListener('click', function () {
          reviewsDetails.open = true;
          reviewsDetails.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      const descBtn = root.querySelector('#description-button');
      const descDetails = root.querySelector('#description-details');
      if (descBtn && descDetails) {
        descBtn.addEventListener('click', function () {
          descDetails.open = true;
          descDetails.scrollIntoView({ behavior: 'smooth', block: 'center'});
        });
      }

      function getSelectedOptions() {
        const values = [];
        fieldsets.forEach(function (fs) {
          const checked = fs.querySelector('[data-option-input]:checked');
          values.push(checked ? checked.value : null);
        });
        return values;
      }

      function findVariant(selectedOptions) {
        if (!productData || !productData.variants) return null;
        return productData.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selectedOptions[i];
          });
        }) || null;
      }

      function formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
      }

      function updateSelectedLabels(selected) {
        fieldsets.forEach(function (fs, i) {
          const label = fs.querySelector('[data-option-selected]');
          if (label) label.textContent = selected[i] || '';
        });
      }

      function update() {
        const selected = getSelectedOptions();
        updateSelectedLabels(selected);
        const variant = findVariant(selected);

        if (!variant) {
          if (submitBtn) {
            submitBtn.disabled = true;
            if (submitText) submitText.textContent = i18n.unavailable;
          }
          return;
        }

        if (variantInput) variantInput.value = variant.id;

        if (submitBtn && submitText) {
          if (variant.available) {
            submitBtn.disabled = false;
            submitText.textContent = i18n.addToBag;
          } else {
            submitBtn.disabled = true;
            submitText.textContent = i18n.soldOut;
          }
        }

        if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
        if (priceWas) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceWas.textContent = (i18n.was || 'Was __PRICE__').replace('__PRICE__', formatMoney(variant.compare_at_price));
            priceWas.hidden = false;
          } else {
            priceWas.hidden = true;
          }
        }

        // Runs after the availability state above so a sold-out variant stays
        // disabled and a limit can only ever tighten the button, not loosen it.
        applyQuantityLimit();

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* noop */ }
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', update);
      });

      // ---- Per-order quantity limit -------------------------------------
      // The cap counts units already in the bag, so the shopper can only ever
      // add the remaining allowance rather than the full limit each time.

      const qtyNote = root.querySelector('[data-quantity-note]');

      function currentVariantId() {
        return variantInput ? String(variantInput.value) : '';
      }

      function limitFor(variantId) {
        return parseInt(qtyLimits[variantId], 10) || 0;
      }

      function variantById(variantId) {
        if (!productData || !productData.variants) return null;
        return productData.variants.find(function (v) {
          return String(v.id) === String(variantId);
        }) || null;
      }

      // The cap that actually applies, and how much of it the bag already uses.
      // For a pooled product the strictest cap declared anywhere in the pool
      // wins, and every pooled line counts toward it.
      function stateFor(variantId) {
        let limit = limitFor(variantId);
        let inCart = cartState.variants[variantId] || 0;

        if (qtyGroup) {
          const pool = cartState.groups[qtyGroup];
          if (pool) {
            inCart = pool.count || 0;
            const poolMax = parseInt(pool.max, 10) || 0;
            if (poolMax > 0 && (limit <= 0 || poolMax < limit)) limit = poolMax;
          }
        }

        const remaining = limit > 0 ? Math.max(0, limit - inCart) : Infinity;
        return { limit: limit, inCart: inCart, remaining: remaining };
      }

      function remainingFor(variantId) {
        return stateFor(variantId).remaining;
      }

      function fill(template, replacements) {
        let out = template || '';
        Object.keys(replacements).forEach(function (token) {
          out = out.split(token).join(replacements[token]);
        });
        return out;
      }

      function syncQuantityOptions(max, selectedValue) {
        if (!qtyInput) return;

        const safeMax = Math.max(1, parseInt(max, 10) || 1);
        const currentSelected = Math.max(1, parseInt(selectedValue, 10) || 1);
        const targetValue = Math.min(currentSelected, safeMax);

        qtyInput.innerHTML = '';
        for (let i = 1; i <= safeMax; i += 1) {
          const option = document.createElement('option');
          option.value = String(i);
          option.textContent = String(i);
          if (i === targetValue) option.selected = true;
          qtyInput.appendChild(option);
        }
      }

      function applyQuantityLimit() {
        const variantId = currentVariantId();
        const state = stateFor(variantId);
        const limit = state.limit;
        const inCart = state.inCart;
        const remaining = state.remaining;

        if (qtyInput) {
          if (limit > 0) {
            const value = parseInt(qtyInput.value, 10) || 1;
            const cappedMax = Math.max(1, Math.min(remaining, 20));
            syncQuantityOptions(cappedMax, value);

            if (remaining <= 0) {
              qtyInput.value = '1';
              qtyInput.disabled = true;
            } else {
              qtyInput.disabled = false;
              if (value > remaining) qtyInput.value = String(remaining);
            }
          } else {
            const value = parseInt(qtyInput.value, 10) || 1;
            syncQuantityOptions(20, value);
            qtyInput.disabled = false;
          }
        }

        // Block add-to-cart once the bag already holds the full allowance. When
        // the allowance frees up again (items removed in the side cart) restore
        // the button — but only for a variant we know is purchasable, so a
        // sold-out variant is never re-enabled.
        if (submitBtn) {
          if (limit > 0 && remaining <= 0) {
            submitBtn.disabled = true;
            if (submitText) submitText.textContent = i18n.maxQtyButton || 'Limit reached';
          } else {
            const variant = variantById(variantId);
            if (variant && variant.available) {
              submitBtn.disabled = false;
              if (submitText) submitText.textContent = i18n.addToBag;
            }
          }
        }

        if (qtyNote) {
          if (limit <= 0) {
            qtyNote.hidden = true;
            qtyNote.textContent = '';
          } else {
            qtyNote.hidden = false;
            const tokens = { '__QTY__': limit, '__REMAINING__': remaining, '__GROUP__': qtyGroup };
            if (remaining <= 0) {
              qtyNote.textContent = fill(qtyGroup ? i18n.maxQtyGroupReached : i18n.maxQtyReached, tokens);
            } else if (inCart > 0) {
              qtyNote.textContent = fill(qtyGroup ? i18n.maxQtyGroupRemaining : i18n.maxQtyRemaining, tokens);
            } else {
              qtyNote.textContent = fill(qtyGroup ? i18n.maxQtyGroup : i18n.maxQty, tokens);
            }
          }
        }
      }

      function hasAnyLimit() {
        if (qtyGroup) return true;
        return Object.keys(qtyLimits).some(function (id) {
          return limitFor(id) > 0;
        });
      }

      // Reads the bag state the side cart publishes. /cart.js can't be used here
      // because it carries no metafields, so it can't say which lines are pooled.
      function syncCartCounts() {
        if (!hasAnyLimit()) return;
        const el = document.querySelector('[data-cart-quantity-state]');
        if (!el) return;
        try {
          const parsed = JSON.parse(el.textContent);
          cartState = {
            variants: parsed.variants || {},
            groups: parsed.groups || {},
          };
        } catch (e) {
          return; // leave the server-rendered state in place
        }
        applyQuantityLimit();
      }

      if (qtyInput) {
        qtyInput.addEventListener('change', applyQuantityLimit);
      }

      // Re-check after the side cart mutates the bag, and on first load in case
      // the page came from a cache that predates the current cart.
      document.addEventListener('sidecart:updated', syncCartCounts);
      syncCartCounts();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidecart"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-sidecart]');
    if (!root) return;

    const panel = root.querySelector('[data-sidecart-panel]');
    const overlay = root.querySelector('[data-sidecart-overlay]');
    const sectionId = root.getAttribute('data-section-id');
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      // next frame so the transition runs
      requestAnimationFrame(function () {
        root.classList.add('sidecart--open');
      });
      document.documentElement.style.overflow = 'hidden';
      const closeBtn = root.querySelector('[data-sidecart-close]');
      if (closeBtn) closeBtn.focus();
      loadRecommendations();
    }

    function close() {
      root.classList.remove('sidecart--open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        root.hidden = true;
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, 300);
    }

    function setLoading(state) {
      root.setAttribute('data-loading', state ? 'true' : 'false');
    }

    function updateHeaderCount(count) {
      const desktop = document.querySelector('[data-cart-count]');
      if (desktop) {
        desktop.classList.toggle('header__checkout--has-items', count > 0);
        const base = desktop.getAttribute('data-cart-label') || desktop.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
        desktop.setAttribute('data-cart-label', base);
        desktop.textContent = count > 0 ? base + ' (' + count + ')' : base;
      }
      const mobile = document.querySelector('[data-cart-count-mobile]');
      if (mobile) mobile.textContent = count;
      // The count is the bag link's only visible text, so it has to stay part
      // of the accessible name too.
      const bag = document.querySelector('[data-cart-bag]');
      if (bag) {
        const template = bag.getAttribute('data-cart-label-template');
        if (template) bag.setAttribute('aria-label', template.replace('COUNT', count));
      }
    }

    // True once a line has been trimmed, so the notice survives the re-render
    // that follows the correction.
    let limitNoticePending = false;
    // Guards reconcileLimits against recursing through its own refreshSection.
    let reconciling = false;

    function showLimitNotice() {
      const notice = root.querySelector('[data-sidecart-limit-notice]');
      if (notice) notice.hidden = false;
    }

    // Backstop for anything that got past the UI caps — a direct /cart/add.js
    // post, a second tab, or a stale page. Trims any line above its metafield
    // limit and re-renders. Client-side only; a Shopify cart-validation
    // function is the only way to make this airtight at checkout.
    function lineQty(li) {
      const valueEl = li.querySelector('[data-qty-value]');
      return parseInt(valueEl ? valueEl.textContent.trim() : '0', 10) || 0;
    }

    function lineMax(li) {
      return parseInt(li.getAttribute('data-max-quantity'), 10) || 0;
    }

    function reconcileLimits() {
      if (reconciling) return Promise.resolve();

      const fixes = [];
      const lines = Array.prototype.slice.call(root.querySelectorAll('[data-line-item]'));

      // Ungrouped lines: each is capped on its own.
      lines.forEach(function (li) {
        if (li.getAttribute('data-quantity-group')) return;
        const max = lineMax(li);
        if (max <= 0) return;
        const qty = lineQty(li);
        if (qty > max) {
          fixes.push({ key: li.getAttribute('data-key'), quantity: max });
        }
      });

      // Pooled lines: the cap applies to the whole pool, so trim upward from the
      // bottom of the list until the pool total fits. Which line gives way is
      // whatever the bag lists last — cart.items order doesn't track add order
      // reliably — but the pool total is always brought within the cap.
      const pools = {};
      lines.forEach(function (li) {
        const group = li.getAttribute('data-quantity-group');
        if (!group) return;
        (pools[group] = pools[group] || []).push(li);
      });

      Object.keys(pools).forEach(function (group) {
        const members = pools[group];

        // Strictest non-zero cap declared by any member wins.
        let max = 0;
        members.forEach(function (li) {
          const lineCap = lineMax(li);
          if (lineCap > 0 && (max === 0 || lineCap < max)) max = lineCap;
        });
        if (max <= 0) return;

        let total = members.reduce(function (sum, li) { return sum + lineQty(li); }, 0);
        if (total <= max) return;

        for (let i = members.length - 1; i >= 0 && total > max; i--) {
          const li = members[i];
          const qty = lineQty(li);
          const excess = total - max;
          const next = Math.max(0, qty - excess);
          if (next === qty) continue;
          fixes.push({ key: li.getAttribute('data-key'), quantity: next });
          total -= qty - next;
        }
      });

      if (!fixes.length) {
        if (limitNoticePending) {
          limitNoticePending = false;
          showLimitNotice();
        }
        return Promise.resolve();
      }

      reconciling = true;
      limitNoticePending = true;

      return fixes
        .reduce(function (chain, fix) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: fix.key, quantity: fix.quantity })
            });
          });
        }, Promise.resolve())
        .then(function () { return refreshSection(); })
        .catch(function (err) { console.error('sidecart limit reconcile', err); })
        .finally(function () {
          reconciling = false;
          if (limitNoticePending) {
            limitNoticePending = false;
            showLimitNotice();
          }
        });
    }

    function refreshSection() {
      return fetch(window.location.pathname + '?section_id=' + sectionId, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-sidecart-panel]');
          if (!fresh || !panel) return;
          panel.innerHTML = fresh.innerHTML;
          loadRecommendations();
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateHeaderCount(cart.item_count); })
            .catch(function () {});
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('sidecart:updated'));
          return reconcileLimits();
        });
    }

    function changeLine(key, quantity) {
      setLoading(true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return refreshSection(); })
        .catch(function (err) { console.error('sidecart change', err); })
        .finally(function () { setLoading(false); });
    }

    function addVariant(form) {
      const formData = new FormData(form);
      if (!formData.get('id')) return Promise.resolve();
      setLoading(true);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () { return refreshSection(); })
        .catch(function (err) { console.error('sidecart add', err); })
        .finally(function () { setLoading(false); });
    }

    function loadRecommendations() {
      const wrap = root.querySelector('[data-sidecart-recommendations]');
      if (!wrap) return;
      // If the server already rendered recommendations, skip refetch.
      if (wrap.querySelector('.sidecart__recommendations-list')) return;
      const url = wrap.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-sidecart-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            wrap.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {});
    }

    // Delegate clicks inside the panel
    root.addEventListener('click', function (e) {
      const closeTrigger = e.target.closest('[data-sidecart-close]');
      if (closeTrigger) {
        e.preventDefault();
        close();
        return;
      }

      if (e.target === overlay || e.target.closest('[data-sidecart-overlay]')) {
        close();
        return;
      }

      const removeBtn = e.target.closest('[data-line-remove]');
      if (removeBtn) {
        const li = removeBtn.closest('[data-line-item]');
        if (!li) return;
        changeLine(li.getAttribute('data-key'), 0);
        return;
      }

      const inc = e.target.closest('[data-qty-increase]');
      const dec = e.target.closest('[data-qty-decrease]');
      if (inc || dec) {
        const li = (inc || dec).closest('[data-line-item]');
        if (!li) return;
        const valueEl = li.querySelector('[data-qty-value]');
        const current = parseInt(valueEl ? valueEl.textContent.trim() : '1', 10) || 1;
        const next = inc ? current + 1 : current - 1;
        if (next < 0) return;

        // Don't let the line — or the pool it belongs to — climb past its cap.
        const max = lineMax(li);
        const group = li.getAttribute('data-quantity-group');
        if (inc && max > 0) {
          let projected = next;
          if (group) {
            // Every other line in the same pool counts toward the same cap.
            root.querySelectorAll('[data-line-item]').forEach(function (other) {
              if (other === li) return;
              if (other.getAttribute('data-quantity-group') === group) projected += lineQty(other);
            });
          }
          if (projected > max) {
            if (inc.tagName === 'BUTTON') inc.disabled = true;
            return;
          }
        }

        changeLine(li.getAttribute('data-key'), next);
      }
    });

    root.addEventListener('submit', function (e) {
      const form = e.target.closest('[data-rec-form]');
      if (!form) return;
      e.preventDefault();
      addVariant(form);
    });

    // Open triggers anywhere in the document
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-sidecart-open]');
      if (!trigger) return;
      e.preventDefault();
      open();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('sidecart--open')) {
        close();
      }
    });

    // Listen for external add-to-cart events to auto-open
    document.addEventListener('cart:added', function () {
      refreshSection().then(open);
    });

    // Intercept Shopify product forms (action="/cart/add") so adding a product
    // opens the sidecart instead of redirecting to /cart.
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.matches('[data-rec-form]')) return; // handled by panel submit
      const action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;
      e.preventDefault();
      setLoading(true);
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) { return res.json(); })
        .then(function () { return refreshSection(); })
        .then(open)
        .catch(function (err) { console.error('sidecart product add', err); })
        .finally(function () {
          setLoading(false);
          if (submitBtn) submitBtn.disabled = false;
        });
    }, true);

    // Trim any line that's already over its cap on first load.
    reconcileLimits();

    // Expose minimal API
    window.SideCart = { open: open, close: close, refresh: refreshSection };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const poster = event.target.closest('[data-video-embed]');
    if (!poster) return;

    const iframe = document.createElement('iframe');
    iframe.src = poster.dataset.videoEmbed;
    iframe.title = poster.dataset.videoTitle || '';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    poster.replaceWith(iframe);
  });

  } catch(e) { console.error(e); }
})();
})();
